<template>
    <div class="bg-[#66A3FF14] text-white rounded-xl border border-[#FFFFFF1F] p-6">
        <div class="flex gap-5">
            <!-- Product Card -->
            <div v-for="product in products" :key="product.id" class=" flex flex-col">
                <!-- Wishlist Icon -->
                <div class=" bg-[#FFFFFF0A] relative rounded-lg  min-h-[172px] py-4 px-6 mb-3">
                    <div class="absolute right-1 top-2">
                        <Button icon="pi pi-heart" aria-label="Add to wishlist" :pt="{ root: { class: '!p-0' }, icon: { class: '!p-0' } }" rounded
                            class="!text-[var(--text-secondary)] !bg-[var(--background-btn)] !border-none">
                        </Button>
                    </div>

                    <!-- Image -->
                    <NuxtImg :src="product.image" :alt="product.name" width="117" height="138" loading="lazy" />
                </div>

                <!-- Product Info -->
                <h3 class="text-white font-medium text-lg mb-1">
                    {{ product.name }}
                </h3>
                <div class="flex items-center text-sm text-gray-400 mb-2">
                    <span class="text-yellow-400 text-xl mr-1">★</span>
                    <span class="text-white font-semibold mr-1">{{ product.rating }}</span>
                    <span class="text-gray-400">({{ product.reviews }} Reviews)</span>
                </div>
                <p class="text-white text-xl font-bold mb-4">
                    ${{ product.price }}
                </p>

                <!-- Add to Cart -->
                <Button unstyled class="mt-auto bg-[#FFFFFF33] text-white font-semibold text-xs py-3 px-6 rounded-lg ">
                    ADD TO CART
                </Button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

const products = [
    {
        id: 1,
        name: "Biker Jacket",
        image: "/images/join-waitlist/Jacket.png",
        price: 120,
        rating: 4.8,
        reviews: 229,
    },
    {
        id: 2,
        name: "Iphone 14",
        image: "/images/product-showcase/iphone.png",
        price: 799,
        rating: 4.6,
        reviews: 1229,
    },
];

</script>
